import styled from "@emotion/styled";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/dist/client/router";
import React from "react";
import { CategoryDetailQuery_category_packages } from "../../graphql/types";
import { makeSlugUrl } from "../../helpers/url";
import { Locale, localePath } from "../../routes";
import { blackButtonStyle } from "../Button";
import CustomLink from "../CustomLink";
import Flex from "../Flex";
import Title from "../Title";
import Image from "next/image";
import Markdown from "markdown-to-jsx";

interface Props {
  packages?: (CategoryDetailQuery_category_packages | null)[] | null;
}

const Packages = ({ packages }: Props) => {
  const { t } = useTranslation("categoryDetail");
  const { locale } = useRouter();
  return (
    <PackagesContainer>
      {packages?.map((item, index) => {
        const isOdd = index % 2 === 0;
        const values = [...(item?.values || [])];
        const valuesByPrice = values?.sort(
          (val1, val2) => (val1?.price?.amount || 0) - (val2?.price?.amount || 0)
        );
        return (
          <PackageItem
            flexDirection={{ _: "column", md: isOdd ? "row" : "row-reverse" }}
            mb={4}
            key={`package-${item?.id}`}
          >
            <DescriptionColumn width={{ _: 1, md: 1 / 3 }}>
              <Title level={3}>
                {item?.title}
              </Title>
              <Description><Markdown>{item?.shortDescription || ""}</Markdown></Description>
              <CustomLink
                ariaLabel={item?.title}
                css={blackButtonStyle}
                href={`${localePath[locale as Locale].packages}/${makeSlugUrl(
                  item
                )}`}
              >
                {" "}
                {t("priceFrom", { price: valuesByPrice?.[0]?.price?.amount })}
              </CustomLink>
            </DescriptionColumn>
            <ImageColumn
              width={{ _: 1, md: 2 / 3 }}
              ml={{ _: 0, md: isOdd ? 5 : 0 }}
              mr={{ _: 0, md: isOdd ? 0 : 5 }}
              mt={{ _: 3, md: 0 }}
            >
              <CustomImage
                src={item?.images?.[0]?.url || "/"}
                alt={item?.images?.[0]?.alternativeText || ""}
                width={800}
                height={550}
              />
            </ImageColumn>
          </PackageItem>
        );
      })}
    </PackagesContainer>
  );
};

export default Packages;

const PackagesContainer = styled(Flex)`
  flex-direction: column;
`;

const PackageItem = styled(Flex)`
  align-items: center;
`;

const ImageColumn = styled(Flex)`
  height: 100%;
  align-items: center;
`;

const DescriptionColumn = styled(Flex)`
  flex-direction: column;
`;

const Description = styled.span`
  margin-bottom: 32px;
`;

const CustomImage = styled(Image)`
  max-width: 100%;
`;
